
// react import
import React from 'react';

// dom imports
import { useNavigate } from 'react-router-dom';

// AppBar from https://v4.mui.com/components/app-bar/#app-bar
import { AppBar, Container, Toolbar, Typography, Select, MenuItem, makeStyles, createTheme, ThemeProvider } from '@material-ui/core'; 

// import state CryptoState from CrytoContext
import { CryptoState } from '../CrytoContext';  
  
const useStyles = makeStyles(() => ({ 
    title: {
        flex: 1,
        color: 'gold',
        fontFamily: 'Montserrat',
        fontWeight: 'bold',
        cursor: 'pointer'
    }
})); 

const Header = () => {

    // used with className
    const classes = useStyles();
    // useHistory() is replaced by useNavigate() ;
    // const history = useNavigate(); 
    const navigate = useNavigate(); 

    const { currency, setCurrency } = CryptoState();
    console.log(currency); 
    const darkTheme = createTheme({
        palette: {
            primary: {
                main: '#fff',
            },
            type: 'dark',
        },
    });

    return (

    <ThemeProvider theme={darkTheme}>
           
        <AppBar color='transparent' position='static'> 
            <Container> 
                <Toolbar>     
                    <Typography onClick={() => navigate('/')} className={classes.title} variant='h6'> Crypto Watch </Typography>
                    <Select defaultValue={'GBP'} variant='outlined' style={{width: 100, height: 40, marginRight: 15}} value={currency} onChange={(e) => setCurrency(e.target.value)}>   
                        <MenuItem value={'GBP'}> GBP </MenuItem>
                        <MenuItem value={'EUR'}> EUR </MenuItem>   
                        <MenuItem value={'USD'}> USD </MenuItem> 
                    </Select> 
                </Toolbar>
            </Container>
        </AppBar>

    </ThemeProvider>   

    )

}

export default Header